module.exports = __webpack_public_path__ + "static/media/logoTextDark.78e3cb67.svg";